import { Banner } from "../coms/Banner";
import React from "react";

export const BannerVam = () => {
    return (
        <>
            <Banner name={"itemsVam"} />
            <Banner name={"itemsBeneficios"} titulo={"Beneficios Banner Redes"} />
        </>
    );
};
